import { render } from "./FrmSettingsSyncContracts.vue?vue&type=template&id=25dcee4e&scoped=true"
import script from "./FrmSettingsSyncContracts.vue?vue&type=script&lang=js"
export * from "./FrmSettingsSyncContracts.vue?vue&type=script&lang=js"

import "./FrmSettingsSyncContracts.vue?vue&type=style&index=0&id=25dcee4e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25dcee4e"]])

export default __exports__